import type { EmbarcacaoGuinchosGuindastesField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const GUINCHOS_GUINDASTES_ID = "guinchos-guindastes";
/** Título no Figma ("Guincho Guindaste"); a HU 1741 escreve "Guincho / Guindaste". */
export const GUINCHOS_GUINDASTES_TITLE = "Guincho Guindaste";
export const GUINCHOS_GUINDASTES_TEST_ID = "embarcacao-guinchos-guindastes";
export const GUINCHOS_GUINDASTES_LOADING_MESSAGE =
  "Carregando os Guinchos e Guindastes da embarcação...";

/** Padrão global de estado vazio do Hub para a embarcação sem guinchos ou guindastes. */
export const GUINCHOS_GUINDASTES_EMPTY_STATE = {
  title: "Nenhuma informação de Guincho Guindaste disponível",
  description:
    "Assim que houver guinchos ou guindastes desta embarcação, eles aparecerão nesta seção.",
};

/** Os 13 campos de cada cartão, na ordem da HU e do protótipo; o primeiro é a identificação do item (RN002). */
export const GUINCHOS_GUINDASTES_FIELDS: DetailFieldDefinition<EmbarcacaoGuinchosGuindastesField>[] =
  [
    { key: "guinchoGuindaste", label: "Guincho / Guindaste" },
    { key: "tipo", label: "Tipo" },
    { key: "modelo", label: "Modelo" },
    { key: "alcance", label: "Alcance (m)" },
    { key: "ahc", label: "AHC?" },
    { key: "profundidade", label: "Profundidade (m)" },
    { key: "capacidadeCarga", label: "Capacidade de Carga SWL (T)" },
    { key: "diametroCabo", label: "Diâmetro do cabo (mm)" },
    { key: "comprimentoCabo", label: "Comprimento do cabo (m)" },
    { key: "materialCabo", label: "Material do cabo" },
    { key: "capacidadeCabo", label: "Capacidade do cabo (MBL)" },
    { key: "pesoCabo", label: "Peso do Cabo (Kg/m)" },
    {
      key: "atualizacaoGuinchoGuindaste",
      label: "Data Atualização Guincho Guindaste",
      format: formatDetailDate,
    },
  ];
